import { styled } from '@mui/material/styles';
import { keyframes } from '@emotion/react';
import { Table, TableRow } from '@mui/material';
import StepProgress from '#component/shipment/step-progress';

const blink = keyframes({
  from: { opacity: 1 },
  to: { opacity: 0.2 }
});

const skeletonLoading = keyframes({
  '0%': { backgroundPosition: '-200px 0' },
  '100%': { backgroundPosition: 'calc(200px + 100%) 0' }
});

export const StyledTable = styled(Table, {
  shouldForwardProp: prop => prop !== 'loading'
})(({ theme, loading }) => ({
  minWidth: 700,
  '& thead': { position: 'relative' },
  '& tr': { cursor: 'pointer' },
  '& th': {
    padding: '14px 14px 14px 22px',
    color: '#667',
    '&.th': { cursor: 'text', paddingTop: '15px' }
  },
  '& td': { paddingRight: 4, paddingLeft: 22, border: 'none' },
  '& td:last-child': { width: 30, padding: '4px 22px 4px 4px' },
  '& tr:nth-of-type(even) > td': { padding: 0 },
  '& tr:last-child > td': { paddingBottom: theme.spacing(0.25) },
  ...(loading && {
    '& tbody tr:nth-of-type(odd)': { filter: 'blur(5px)' },
    '& tbody tr:nth-of-type(even)': { filter: 'blur(1px)' },
    '& tbody th, & tbody td': { animation: `${blink} 1.5s alternate infinite linear` }
  })
}));

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: prop => prop !== 'clickable' && prop !== 'skeleton'
})(({ clickable, skeleton }) => ({
  textDecoration: 'none',
  ...(clickable && { cursor: 'pointer' }),
  ...(skeleton && {
    height: 56,
    width: '100%',
    display: 'inline-block',
    margin: 6,
    borderRadius: 4,
    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    animation: `${skeletonLoading} 1.5s linear infinite`,
    '&:nth-of-type(1)': { marginTop: 12 },
    '& td': { display: 'none' }
  })
}));

export const StyledStepProgress = styled(StepProgress)({
  margin: '0 !important'
});
